import { render, staticRenderFns } from "./recallRetrieveTask.vue?vue&type=template&id=1a9e37e1&scoped=true"
import script from "./recallRetrieveTask.vue?vue&type=script&lang=js"
export * from "./recallRetrieveTask.vue?vue&type=script&lang=js"
import style0 from "./recallRetrieveTask.vue?vue&type=style&index=0&id=1a9e37e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9e37e1",
  null
  
)

export default component.exports